import { render, staticRenderFns } from "./goldsilverinreturn.vue?vue&type=template&id=6d432e3e&scoped=true&"
import script from "./goldsilverinreturn.vue?vue&type=script&lang=js&"
export * from "./goldsilverinreturn.vue?vue&type=script&lang=js&"
import style0 from "./goldsilverinreturn.vue?vue&type=style&index=0&id=6d432e3e&scoped=true&lang=scss&"
import style1 from "./goldsilverinreturn.vue?vue&type=style&index=1&lang=css&"
import style2 from "./goldsilverinreturn.vue?vue&type=style&index=2&id=6d432e3e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d432e3e",
  null
  
)

export default component.exports